export default function Rust_Home() {
  return (
    <div>
      <h1>Rust_Home Component</h1>
      <p>This is the Rust_Home page.</p>
    </div>
  );
}
